<div
  class="df-confirm-overlay d-flex ion-align-items-center ion-justify-content-center ion-padding"
  *ngIf="isOpen"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId"
  (click)="onBackdropClick()"
  (keydown)="onDialogKeydown($event)"
>
  <div
    #dialogContainer
    class="df-confirm-card card-white-background-color ion-text-center pad16"
    (click)="$event.stopPropagation()"
  >
    <div
      *ngIf="icon"
      class="df-confirm-icon d-flex ion-align-items-center ion-justify-content-center m-auto"
      [class.df-confirm-icon--alert]="iconTone === 'alert'"
      [class.df-confirm-icon--accent]="iconTone === 'accent'"
    >
      <ion-icon [name]="icon"></ion-icon>
    </div>
    <div
      [id]="titleId"
      class="fs-5 font700 dutyfree-text-color"
      [class.mart16]="!!icon"
    >
      {{ title }}
    </div>
    <div
      class="fs-2 font400 dutyfree-text-secondary mart10 l-height150"
      *ngIf="message"
      [innerHTML]="message"
    ></div>
    <div class="df-confirm-actions mart24">
      <ion-button
        #primaryAction
        expand="block"
        class="df-confirm-primary fs-3 font700 mar0"
        [disabled]="busy"
        (click)="onPrimaryClick()"
      >
        {{ primaryLabel }}
      </ion-button>
      <button
        type="button"
        class="df-confirm-cancel fs-2 font700 dutyfree-text-secondary cursor-pointer"
        *ngIf="showSecondary"
        [disabled]="busy"
        (click)="onSecondaryClick()"
      >
        {{ secondaryLabel }}
      </button>
    </div>
  </div>
</div>
